import gql from 'graphql-tag';

export const GET_DASHBOARD_LIST = gql`
  query GetDashboardList($input: ExternalDashboardsInput!) {
    externalDashboards {
      result: externalDashboards(input: $input) {
        error
        success
        list {
          id
          url
          name
          icon
          type
          description
        }
      }
    }
  }
`;
